/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Intro_TitleInputs */

const es_marketplace_seo_galicia_guide_intro_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler de barcos en Galicia y las Rías Baixas`)
};

const gl_marketplace_seo_galicia_guide_intro_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiro de barcos en Galicia e as Rías Baixas`)
};

const en_marketplace_seo_galicia_guide_intro_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat rental in Galicia and Rías Baixas`)
};

/**
* | output |
* | --- |
* | "Boat rental in Galicia and Rías Baixas" |
*
* @param {Marketplace_Seo_Galicia_Guide_Intro_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_intro_title = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Intro_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Intro_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_intro_title(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_intro_title(inputs)
	return es_marketplace_seo_galicia_guide_intro_title(inputs)
});